/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Button, Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { ScrollTracking, TrackedComponent, useAvroTracking } from 'tracking';
import { getLinkTarget } from 'utils/getLinkTarget';

export type Props = {
  heading?: string;
  subheading?: string;
  buttonText?: string;
  buttonUrl?: string;
};

const Styles = labelStyles('EmbeddedHalfWidthCTA', {
  root: css({
    backgroundColor: Colors.peach,
    borderRadius: '5px',
    margin: '20px auto',
    padding: '20px',
    textAlign: 'center',
    width: '100%',

    [mediaQueries.tablet]: {
      float: 'right',
      padding: '24px',
      marginLeft: '20px',
      width: '50%',
    },
  }),

  heading: css({
    ...Typography.sectionHeader3Bold,
    color: Colors.neutral800,
  }),

  subheading: css({
    ...Typography.paragraph1Short,
    color: Colors.neutral800,
    marginTop: '8px',
  }),

  button: css({
    marginTop: '24px',
  }),
});

export const EmbeddedHalfWidthCTA = (props: Props) => {
  const { emitCTAClickEvent } = useAvroTracking();
  return (
    <ScrollTracking avroIdentifier={TrackedComponent.HalfWidthCTA}>
      <aside css={Styles.root} data-testid="half-width-cta">
        {props.heading && <div css={Styles.heading}>{props.heading}</div>}
        {props.subheading && (
          <div css={Styles.subheading}>{props.subheading}</div>
        )}
        {props.buttonUrl && props.buttonText && (
          <div css={Styles.button}>
            <Button
              href={props.buttonUrl}
              target={getLinkTarget(props.buttonUrl)}
              color="primary-alt"
              onClick={() => {
                emitCTAClickEvent({
                  interaction_raw_text: props.buttonText,
                  destination_url_address: props.buttonUrl,
                  custom_tracking_fields: {
                    component: TrackedComponent.HalfWidthCTA,
                    heading: props.heading,
                    subheading: props.subheading,
                  },
                });
              }}
            >
              {props.buttonText}
            </Button>
          </div>
        )}
      </aside>
    </ScrollTracking>
  );
};
